import { Permission } from './permission.model';
import { PermissionGroupResponse } from '../interfaces/permission-group.response';
import { PermissionType } from './permission-type.enum';

export class PermissionGroup {
  public id: number;
  public name: string;
  public permissions: Permission[];

  constructor(response?: PermissionGroupResponse) {
    if (response) {
      this.id = response.id;
      this.name = response.name;
      this.permissions = response.permissions
        ? response.permissions.map((permission) => new Permission(permission))
        : [];
    }
  }

  public hasType(type: PermissionType): boolean {
    return !!this.permissions.find((i) => i.type === type);
  }

  public getByType(type: PermissionType): Permission {
    return this.permissions.find((i) => i.type === type);
  }
}
